var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconlyBrokenHeart5896217F(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Broken_Heart",
    "data-name": "Iconly/Broken/Heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.69,
    height: 29.156,
    viewBox: "0 0 30.69 29.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Heart-2",
    "data-name": "Heart",
    d: "M14.379,28.962a52.649,52.649,0,0,1-9.194-7.186A18.989,18.989,0,0,1,.623,14.466a12.189,12.189,0,0,1,.569-9.1,9.525,9.525,0,0,1,5.7-4.9A10.074,10.074,0,0,1,15.354,1.6,10.071,10.071,0,0,1,23.816.465a9.528,9.528,0,0,1,5.7,4.9,12.121,12.121,0,0,1,.514,9.145,19.217,19.217,0,0,1-4.549,7.311,36.667,36.667,0,0,1-4.318,3.792l-.081.069a1.111,1.111,0,0,1-1.544-.3,1.146,1.146,0,0,1-.2-.858,1.131,1.131,0,0,1,.467-.742A35.871,35.871,0,0,0,23.87,20.2a16.8,16.8,0,0,0,4.063-6.414,9.736,9.736,0,0,0-.461-7.366A7.337,7.337,0,0,0,23.1,2.671a7.739,7.739,0,0,0-7.082,1.255,1.119,1.119,0,0,1-1.353,0A7.726,7.726,0,0,0,7.582,2.671,7.338,7.338,0,0,0,3.168,6.41a9.826,9.826,0,0,0-.434,7.339,16.865,16.865,0,0,0,4.063,6.4,50.662,50.662,0,0,0,8.828,6.9,1.17,1.17,0,0,1,.441,1.286A1.141,1.141,0,0,1,15,29.156H15A1.082,1.082,0,0,1,14.379,28.962Zm8.326-17.931A3.027,3.027,0,0,0,20.62,8.272a1.17,1.17,0,0,1-.478-1.344,1.137,1.137,0,0,1,1.168-.794,5.32,5.32,0,0,1,3.643,4.621,1.153,1.153,0,0,1-.226.842,1.106,1.106,0,0,1-.749.427,1.127,1.127,0,0,1-.147.01A1.145,1.145,0,0,1,22.705,11.031Z",
    transform: "translate(0 0)",
    fill: "#ff4557"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBrokenHeart5896217F);
export default __webpack_public_path__ + "static/media/Iconly-Broken-Heart.5896217f.5896217fc44de5d70371f7c9dd8988f8.svg";
export { ForwardRef as ReactComponent };